export default {"src":"/_next/static/media/1.2-h.8f3e4a3b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};